import { render } from "./PrintComponent.vue?vue&type=template&id=20e9b1a2"
import script from "./PrintComponent.vue?vue&type=script&lang=js"
export * from "./PrintComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/buttons/export/PrintComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20e9b1a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20e9b1a2', __exports__)) {
    api.reload('20e9b1a2', __exports__)
  }
  
  module.hot.accept("./PrintComponent.vue?vue&type=template&id=20e9b1a2", () => {
    api.rerender('20e9b1a2', render)
  })

}


export default __exports__